import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from '../assets/images/logo.png';

const hashLink = (hash) => ({ pathname: '/', hash });

const navigationLinks = [
  { label: 'Home', to: hashLink('#home') },
  { label: 'About Us', to: hashLink('#about') },
  { label: 'How It Works', to: hashLink('#how-it-works') },
  { label: 'Partners', to: hashLink('#partners') },
  { label: 'Contact', to: hashLink('#contact') },
];

const legalLinks = [
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Terms of Service', to: '/terms-of-service' },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/90 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-4">
        <Link to="/" className="flex items-center gap-3">
          <img
            src={logo}
            alt="Dial TPR"
            className="h-10 w-10 rounded-full border border-emerald-200 object-cover"
          />
          <div className="flex flex-col">
            <span className="text-lg font-semibold text-emerald-600">Dial TPR</span>
            <span className="text-xs uppercase tracking-[0.2em] text-slate-500">Call &amp; Deliver</span>
          </div>
        </Link>
        <nav className="hidden items-center gap-4 text-sm font-medium text-slate-600 md:flex">
          {navigationLinks.map((item) => (
            <Link key={item.label} to={item.to} className="transition hover:text-emerald-600">
              {item.label}
            </Link>
          ))}
          {legalLinks.map((item) => (
            <Link key={item.label} to={item.to} className="transition hover:text-emerald-600">
              {item.label}
            </Link>
          ))}
          <a
            href="tel:+919176687956"
            className="inline-flex items-center gap-2 rounded-full bg-emerald-500 px-5 py-2 text-white shadow-lg shadow-emerald-200 transition hover:-translate-y-0.5 hover:bg-emerald-600"
          >
            Call Now
          </a>
          <a
            href="https://wa.me/919176687956"
            className="inline-flex items-center gap-2 rounded-full border border-emerald-500 px-5 py-2 text-emerald-600 transition hover:bg-emerald-50"
          >
            WhatsApp Us
          </a>
        </nav>
        <button
          type="button"
          className="rounded-full border border-emerald-200 p-2 text-emerald-600 transition hover:bg-emerald-50 focus:outline-none focus:ring-2 focus:ring-emerald-400 md:hidden"
          onClick={() => setIsMenuOpen((prev) => !prev)}
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation menu"
        >
          {isMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>
      <div
        className={`md:hidden ${
          isMenuOpen ? 'block' : 'hidden'
        } border-t border-slate-200 bg-white/95 text-slate-700 shadow-lg`}
      >
        <div className="mx-auto flex max-w-6xl flex-col gap-3 px-6 py-4 text-sm font-medium">
          {navigationLinks.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className="rounded-lg px-3 py-2 transition hover:bg-emerald-50 hover:text-emerald-600"
              onClick={() => setIsMenuOpen(false)}
            >
              {item.label}
            </Link>
          ))}
          <div className="flex flex-col gap-2 pt-2">
            <a
              href="tel:+919176126422"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 px-5 py-2 text-white shadow-md shadow-emerald-200 transition hover:-translate-y-0.5 hover:bg-emerald-600"
              onClick={() => setIsMenuOpen(false)}
            >
              Call Now
            </a>
            <a
              href="https://wa.me/919176687956"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-emerald-500 px-5 py-2 text-emerald-600 transition hover:bg-emerald-50"
              onClick={() => setIsMenuOpen(false)}
            >
              WhatsApp Us
            </a>
            {legalLinks.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                className="rounded-lg px-3 py-2 text-left text-slate-600 transition hover:bg-emerald-50 hover:text-emerald-600"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
